import React from 'react';

import classNames from 'classnames';
import '../controls.scss';

const ProgressStep = ({ loaded, width, prognose, step }) => {
  const dynamicWidth = { width: `${width}%` };
  const stepStyle = classNames(
    'mt-progress-bar-step',
    {
      'mt-not-loaded': !loaded && prognose.indexOf(step) === -1,
      'mt-not-loaded-prognose': !loaded && prognose.indexOf(step) > -1,
      'mt-loaded': loaded && prognose.indexOf(step) === -1,
      'mt-loaded-prognose': loaded && prognose.indexOf(step) > -1,
    }
  );
  return (
    <div className={stepStyle} style={dynamicWidth}></div>
  );
};

export default ProgressStep;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/ProgressStep.js
 **/